<template>
    <b-navbar toggleable="md" type="light" variant="light">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-navbar-brand>
            <b-link :to="{ name: 'Home' }">
                TNP Admin
            </b-link>
        </b-navbar-brand>

        <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav>
                <b-nav-item :to="{ name: 'OrderPicturesPage' }">Bilder sortieren</b-nav-item>
                <b-nav-item  :to="{ name: 'CategoriesPage' }">Kategorien</b-nav-item>
                <b-nav-item :to="{ name: 'CreatePicturePage' }">neues Bild</b-nav-item>
            </b-navbar-nav>
        </b-collapse>
        <amplify-sign-out v-if="user"></amplify-sign-out>
    </b-navbar>
</template>

<script>
import { Auth, Hub } from 'aws-amplify';
import AmplifyStore from '../store/store';


export default {
    name: 'Menu',
    data () {
        return {}
    },
    computed: {
        user() { 
            return AmplifyStore.state.user
        }
    },
    methods: {
        home: function() {
            this.$router.push('/')
        },
        signOut: function() {
            this.$router.push('/auth/signOut')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Menu.vue